import img from "../assets/images/background.png";
import img2 from "../assets/images/background2.png";
import img3 from "../assets/images/background3.png";
import img4 from "../assets/images/background4.png";
import img5 from "../assets/images/background5.png";

const storyData = [
  {
    image: img,
    story:
      "Once upon a time, there was an Alien, whose name was Oom. Oom lived in Space, on planet XXXX.Oom was very excited because when aliens turn 5, they get to fly spaceships for the very first time. Can you see Oom waving? Say Hello to Oom!!",
  },
  {
    image: img2,
    story:
      "Oom was doing a super job at flying the spaceship but then suddenly ???",
  },
  {
    image: img3,
    story:
      "Oom's spaceship began whirling and twirling out of control, heading straight towards planet Earth.",
  },
  {
    image: img4,
    story:
      "It didn't take too long for Oom's spaceship to crash on Earth, luckily Oom was safe, but with a broken spaceship and no fuel, how will Oom ever get back to planet XXXX?",
  },
  {
    image: img5,
    story:
      'Squirrel to Oom: "Hello, who are you? What\'s your name? Where are you from? How did you get here?"',
  },
  {
    image: img5,
    story: "Can you see the pictures highlighted above in yellow?",
  },
];

export default storyData;
